import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import './list_group_collection.scss';

const ListGroupCollectionItem = props => (
  <Link
    to={props.link_to}
    className="list-group-item list-group-item-action"
    target={props.link_new_window ? '_blank' : null}
  >
    <Container className="w-100">
      <Row>
        <Col sm="6" className="collection-item-primary">
          <h5 className="collection-item-title">{props.title}</h5>
          <div className="subtext">{props.sub_title}</div>
        </Col>
        <Col sm="3" className="collection-item-secondary">
          <div className="subtext">{props.middle_text}</div>
        </Col>
        <Col sm="3" className="collection-item-meta">
          <div className="subtext float-md-right text-sm-right">
            <em>{props.right_text}</em>
          </div>
        </Col>
      </Row>
    </Container>
  </Link>
);

ListGroupCollectionItem.propTypes = {
  title: PropTypes.string,
  sub_title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  middle_text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  right_text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  link_to: PropTypes.string,
  link_new_window: PropTypes.bool,
};

export default ListGroupCollectionItem;
